!function () {
	var container= jhc.commElem.container
		, $IndexClass= jhc.Class.IndexClass;
	function SendMail() {};
	$.extend( SendMail.prototype, {

		init: function(node) {
			this.document= $(document),
			this.body= document.body,
			this.formArea= document.getElementById('form-mail-wrap'),
			this.datas= this.formArea.getElementsByClassName('data'),
			this.dataItm= this.formArea.getElementsByClassName('data-item'),
			this.submitBtn= this.formArea.getElementsByClassName('submit-button')[0],
			this.privatCheck= document.getElementById('private-form'),
			this.alertArea= document.getElementsByClassName('alert')[0],
			this.fromUrl= document.getElementById('from-url'),
			this.checkingElem= this.formArea.querySelectorAll('[data-checking="num"]'),
			this.modalContactBtn= document.getElementById('modal-contact-btn'),
			this.noticeDebounce= $IndexClass.noticeDebounce
		},
		run: function () {
			this.onlyNumSearch(this.checkingElem);
			this.finalSubmit();
			$IndexClass.showModalFront(this.modalContactBtn);
		},
		
		josaFilter: function( str ) {
			var code = str.charCodeAt(str.length-1) - 44032
				, josa= (code % 28 === 0) ? '를' : '을';
			return josa;
		},
		onlyNumSearch: function( elem ){
			var res= /([^0-9])|([~!@\#$%^&*\()\-=+_'])/g,
				value;
			_jh.on('blur', elem, function(e) {
				if(res.test(this.value)){
					alert('숫자만 입력 가능합니다.');
					$(this).val(this.value.replace(/([^0-9])|([~!@\#$%^&*\()\-=+_'])/g,""))
						   .focus();
				}
			});
		},
		dataChecked: function( _self ) {
			var josa= this.josaFilter(_self.title);
			this.noticeDebounce($(this.alertArea), _self.title + josa + ' 입력하지 않으셨습니다.');
			console.dir($IndexClass.topHeight)
			$.Velocity($(_self), 'scroll', { duration: 250, delay: 500, offset: -$IndexClass.topHeight });
			$(_self).focus();
			return false;
		},
		dataLoop: function() {
			var that= this,
				loop= true,
				data= {};

			_jh.each( this.datas, function(i, v) {
				var name= this.dataset.name || this.name
					,	type= this.dataset.type;
				if( type === 'select' ) {
					var checkboxElems= this.querySelectorAll('[name="' + name + '"]')
		    		, checkboxVal= this.querySelectorAll('[data-checkbox-value]')
		    		, checkboxReq= this.dataset.required !== undefined
		    		, arr= [], val;

	    		_jh.each(checkboxElems, function(key, value){
		    		var valEl= checkboxVal[key];
		    		if( this.checked ) {
		    			val= valEl.dataset.checkboxValue;
		    			arr.push(val);
		    		}
		    	});

		    	if( arr.length === 0 && checkboxReq ) {
		    		loop= that.dataChecked(this);
						return false;
		    	} else {
		    		data[name]= arr.toString();
		    	}
		    	
				} else {

					if( this.value === '' && this.required ) {
						loop= that.dataChecked(this);
						return false;
					}
					switch(name){
						case 'email':
							var regExp = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
							if (this.value && this.value.match(regExp) === null) {
								that.noticeDebounce($(that.alertArea), '이메일형식을 확인해 주세요.');
								$(this).focus();
								loop= false;
								return false;
							}
							break;
					}
					data[name]= this.value;

				}
			});
			return loop ? data : false;
		},
		finalSubmit: function() {
			var that= this,
				obj, data;
			this.submitBtn.addEventListener('click', function(e) {
				if( !that.privatCheck[0].checked ) {
					that.noticeDebounce($(that.alertArea), '개인정보 제공에 동의하지 않았습니다.');
					return;
				}
				data= that.dataLoop();
				if(!data) { return; }
				// console.dir(data);
				
				obj= {
					url: '/dist/formmail.php',
					formdata: data,
					syncprint: false,
					complete: function(res) {
						if ( res === 'success' ) {
							that.noticeDebounce($(that.alertArea), "문의사항이 전송 완료 되었습니다!");
							that.formClear();
						} else {
							that.noticeDebounce($(that.alertArea), "전송중 에러가 발생했습니다.");
						}
					}
				}
				$(that.alertArea).AjaxPrint(obj);
				
			});
		},
		formClear: function () {
			_jh.each(this.dataItm, function (i,v) {
				v.value= '';
				v.checked= false;
			});
		}

	});
	var _SendMail= new SendMail();
	_SendMail.init(container);
	_SendMail.run();
}()